import { bool, number, object, string } from 'prop-types';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames/bind';
import { dt } from '../../../helpers/Utils/GetTailwindToken';
import * as styles from '../accordion.css';

const cx = classNames.bind(styles);

const Panel = React.memo(
    ({
        panel,
        toggleControlLeft,
        panelLeftIndent,
        isExpanded,
        parentSection,
        index,
        isGalleryFilter,
    }) => {
        return (
            <div
                id={
                    parentSection.length > 0
                        ? `${parentSection}-accordion-panel-${index}`
                        : `accordion-panel-${index}`
                }
                aria-labelledby={
                    parentSection.length > 0
                        ? `${parentSection}-accordion-button-${index}`
                        : `accordion-button-${index}`
                }
                className={cx('panel-wrapper')}
                role="region"
            >
                <AnimateHeight
                    contentClassName={dt([
                        isGalleryFilter ? '' : 'px-4',
                        'relative',
                        'text-small',
                        toggleControlLeft && panelLeftIndent ? 'ml-4' : '',
                    ])}
                    duration={0}
                    delay={0}
                    height="auto"
                >
                    {isExpanded && panel}
                </AnimateHeight>
            </div>
        );
    },
    (prevProps, nextProps) => {
        return prevProps.isExpanded === nextProps.isExpanded && prevProps.panel === nextProps.panel;
    }
);

Panel.propTypes = {
    panel: object.isRequired,
    toggleControlLeft: bool.isRequired,
    panelLeftIndent: bool.isRequired,
    isExpanded: bool.isRequired,
    index: number.isRequired,
    parentSection: string.isRequired,
};

export default Panel;
